


























































































import MainMixin from '@/product/mixins/main'
import Snackbar from '@/common/components/Snackbar.vue'
import SizeInputRequest from '@/product/components/SizeInputRequest.vue'
import SeriesProducts from '@/product/components/SeriesProducts.vue'
import SimilarProducts from '@/product/components/SimilarProducts.vue'
import MobileContainer from '@/product/components/MobileContainer.vue'
import { ProductState, AddonProductOption } from '@/product/types'
import PrintingOptions from '@/product/components/printingOptions/PrintingOptions.vue'
import Announcements from '@/common/components/announcements/Announcements.vue'
import ProductSize from '@/product/components/ProductSize.vue'

import {
  BQ_EVENT_NAMES,
  EVENT_ACTIONS,
  EVENT_CATEGORIES,
  EVENT_LABELS,
  gaEventTracker,
  googleAdsTracker,
  raksulBQEventTracker
} from '@/common/utils/eventTracker'
import { ADDON_PRODUCT_NONE } from '@/product/const'
import productServices from '@/product/services'
import { SnackbarModel } from '@/common/types'
import { MOBILE_BREAKPOINT } from '@/common/const'

export default MainMixin.extend({
  components: {
    Snackbar,
    SizeInputRequest,
    SeriesProducts,
    SimilarProducts,
    MobileContainer,
    PrintingOptions,
    Announcements,
    ProductSize
  },
  props: {
    initData: {
      type: Object,
      required: true
    }
  },
  data(): {
    isMobileView: boolean
  } {
    return {
      isMobileView: window.innerWidth < MOBILE_BREAKPOINT
    }
  },
  computed: {
    productId(): string | number {
      return this.initData.product.id
    },
    snackbarMessages(): SnackbarModel[] {
      return [{...(this.$store.state as ProductState).snackbarMessage}]
    },
    unpublished(): boolean {
      return this.$store.getters.isProductUnpublished
    },
    brandName(): string {
      return this.storeState.productDetail.product.brandName
    },
    linkToSimilarProducts(): string {
      return `/search?category=${this.categoryId}&f_brand=${this.brandName}`
    }
  },
  created() {
    const { addonPsi, designVersion, optionIds } = this.$route.query
    const { id } = this.$route.params
    this.$store.commit('setIsMobileView', this.isMobileView)
    if (designVersion) {
      this.$store.commit('setStockLibraryDesign', {
        userDesignVersionUuid: designVersion
      })
    }
    this.$store.dispatch('initProductDetail', this.initData)
    if (this.hasAddonProducts) {
      this.getAddonProducts()
    }
    if (this.hasAdditionalOptions) {
      this.getAdditionalOptions()
    }

    if (optionIds) {
      this.$store.commit(
        'setSelectedAdditionalOptionIds',
        (optionIds as string).split(',')
      )
    }
    if (addonPsi === ADDON_PRODUCT_NONE) {
      const payload = {
        selectedAddonProductId: ADDON_PRODUCT_NONE
      } as AddonProductOption
      this.$store.commit('setAddonProduct', payload)
    }
    googleAdsTracker({
      value: this.storeState.estimate.productUnitPriceTaxIncluded,
      itemIds: [id]}
    )
    if (document.referrer) {
      const referrerUrl = new URL(document.referrer)
      if (referrerUrl.origin === window.location.origin && referrerUrl.pathname === '/search'
        && referrerUrl.searchParams.get('keyword')) {
        this.trackingProductClickFromSearch(id, referrerUrl.searchParams.get('keyword') as string)
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      this.isMobileView = window.innerWidth < MOBILE_BREAKPOINT
      this.$store.commit('setIsMobileView', this.isMobileView)
    },
    async getAddonProducts() {
      const data = await productServices.getAddonProducts(this.productId)
      if (data) {
        this.$store.commit('setAddonProducts', data)
      }
    },
    async getAdditionalOptions() {
      const data = await productServices.getAdditionalOptions(this.productId)
      if (data) {
        this.$store.commit('setAdditionalOptions', data)
      }
    },
    confirmError(errorType: string) {
      this.$store.commit('readSelectionErrorItem', errorType)
    },
    trackingProductClickFromSearch(productId: string, searchKeyword: string) {
      raksulBQEventTracker({
        eventName: BQ_EVENT_NAMES.SEARCH_RESULT_CLICK,
        data: {
          productId: productId,
          keyword: searchKeyword
        }
      })
      gaEventTracker(EVENT_CATEGORIES.SEARCH, EVENT_ACTIONS.CLICK, EVENT_LABELS.SEARCH_RESULT_CLICK)
    },
    onConfirmSnackbar() {
      this.$store.commit('setSnackbarVisibility', false)
    }
  }
})
